"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class Index {
    constructor(parent) {
        this.parent = parent;
        this.rc = parent.rc;
    }
    path() {
        return `${this.parent.path()}/authorize`;
    }
    /**
     * Performs OAuth 2.0 authorization (GET version)
     * HTTP Method: get
     * Endpoint: /restapi/oauth/authorize
     * Rate Limit Group: Auth
     */
    async get(restRequestConfig) {
        const r = await this.rc.get(this.path(), undefined, restRequestConfig);
        return r.data;
    }
    /**
     * Performs OAuth 2.0 authorization (POST version)
     * HTTP Method: post
     * Endpoint: /restapi/oauth/authorize
     * Rate Limit Group: Auth
     */
    async post(authorizeRequest, restRequestConfig) {
        const r = await this.rc.post(this.path(), authorizeRequest, undefined, restRequestConfig);
        return r.data;
    }
}
exports.default = Index;
//# sourceMappingURL=index.js.map